export enum PhoneNumberType {
    Cell = "Cell", 
    Home = "Home", 
    Business = "Business", 
    Fax = "Fax", 
    Other = "Other"
}

export interface PhoneNumber {
    phoneNumberType: PhoneNumberType; 
    phoneNumber: string;
}

export const defaultPhoneNumber: PhoneNumber = {
    phoneNumberType: PhoneNumberType.Cell, 
    phoneNumber: ''
}